<script>
import EmployeeManagementInvitationWizard from './EmployeeManagementInvitationWizard.vue'
import EmployeeManagementInvitationConfirmation from './EmployeeManagementInvitationConfirmation.vue'
export default {
  components: {
    InvitationWizard: EmployeeManagementInvitationWizard,
    InvitationConfirmation: EmployeeManagementInvitationConfirmation
  },
  data() {
    return {
      dialog: false,
      loading: false,
      user: { exists: false, email: '' }
    }
  },
  methods: {
    /**
     * user don't exists and have a valide email.
     * send invitation
     */
    onChecked(user) {
      this.user = user
      if (!this.user.exists && this.user.email) {
        this.addUser(this.user.email)
      }
    },
    onFinished() {
      this.reset()
      this.loading = false
      this.$emit('refetch-users')
    },
    /**
     * Admin Confirmed the invitation for an existing user
     */
    onConfirmed() {
      this.addUser(this.user.email)
    },
    /**
     * Add user to Oranization
     * User will be automatically created if not exists
     */
    async addUser(email) {
      this.loading = true
      await this.$organizationService
        .addUser({
          email: email,
          envUrl: `${window.config.VUE_APP_BASE_URL}`
        })
        .then(() => {
          this.$notify(
            this.$t('component.profile.administrationManagement.invite.success', {
              Email: email
            }),
            { type: 'success'}
          )
          this.$emit('invited')
        })
        .catch(() => {
              this.$notify(
                this.$t('component.profile.administrationManagement.invite.error'),
                { type: 'error' }) })
              .finally(() => {
          this.reset()
          this.loading = false
        })
    },
    exportCSV() {
      const organizationId = this.$store.getters.selectedOrganization.id || null
      this.$organizationService
        .exportCSV(organizationId)
        .then((response) => {
          this.$organizationService.clientCSVDownload(response, response.data.filename || 'member_export.csv')
        })
        .catch(() => {
          this.$notify(
            this.$t('component.profile.administrationManagement.csv.error'), {
              type: 'error'
            })
        })
    },
    /**
     * Reset all data
     */
    reset() {
      this.dialog = false
      this.loading = false
      this.finished = false
      this.user = { exists: false, email: '' }
    }
  }
}
</script>
<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="800" transition="dialog-bottom-transition">
      <template #activator="{ on, attrs }">
        <v-btn-toggle class="me">
          <v-btn
            color="primary" class="me-1 standalone-toggle-button" dark
            @click.stop.prevent="exportCSV">
            <v-icon color="white">mdi-file-export</v-icon>
            {{$t('button.csv.export')}}
          </v-btn>
          <v-btn color="primary" class="standalone-toggle-button" dark v-bind="attrs" v-on="on">
            <v-icon color="white">mdi-plus</v-icon>
            {{ $t('button.invite.coworker') }}
          </v-btn>
        </v-btn-toggle>
      </template>
      <v-card>
        <DialogBaseColoredTitle color="primary">{{
            $t('component.profile.administrationManagement.invite')}}
        </DialogBaseColoredTitle>
        <DialogBaseCloseIcon color="white" @click="dialog = false" />
        <v-divider></v-divider>
        <v-expand-transition>
          <InvitationWizard
            v-if="!user.exists"
            :invitation-loading="loading"
            @checked="onChecked"
            @finished="onFinished"
            @cancel="reset" />
          <InvitationConfirmation
            v-if="user.exists"
            :email="user.email"
            :invitation-loading="loading"
            @confirmed="onConfirmed"
            @cancel="reset" />
        </v-expand-transition>
      </v-card>
    </v-dialog>
  </div>
</template>
<style scoped>
.standalone-toggle-button {
  opacity: 1 !important;
  color: white !important;
  border-radius: 5px !important;
  border: none !important;
}
</style>
